"use strict";
var index_1 = require('./src/index');
exports.Angular2FontawesomeModule = index_1.Angular2FontawesomeModule;



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular2-fontawesome/angular2-fontawesome.js
// module id = ./node_modules/angular2-fontawesome/angular2-fontawesome.js
// module chunks = vendor